const convertDateToPattern = (date: Date) => {
  // const { getMonth, getDay, getFullYear, getHours, getMinutes } = date;

  return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()} 00:00`;
};

export default convertDateToPattern;
